import { render } from "./press-logos.vue?vue&type=template&id=2abaa2cd&scoped=true"
import script from "./press-logos.vue?vue&type=script&lang=js"
export * from "./press-logos.vue?vue&type=script&lang=js"

import "./press-logos.vue?vue&type=style&index=0&id=2abaa2cd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abaa2cd"]])

export default __exports__